const { forEach, find, endsWith } = require('lodash');

class DynamicContentScheduleKeyService {
    constructor(settings) {
        this.settings = settings;
        this.globalScheduleInclusions = null;
    }

    /**
     * Gets a mapping of all paths to show global dynamic content on.
     * @example
     * {
     *  '/shop': true, (Show global content on /Shop)
     *  '/shop/*': true, (Show global content on /Shop and all it's children)
     * }
     * @returns {Object}
     */
    getGlobalScheduleInclusions() {
        if (this.globalScheduleInclusions) {
            return this.globalScheduleInclusions;
        }

        this.globalScheduleInclusions = {};

        forEach(this.settings.dynamicContent.globalScheduleLocations, (exclusion) => {
            if (endsWith(exclusion, '/')) {
                exclusion = exclusion.substr(0, exclusion.length - 1);
            }
            this.globalScheduleInclusions[exclusion.toLowerCase()] = true;
        });

        return this.globalScheduleInclusions;
    }

    /**
     * Returns true if the provided path matches a path in the global schedule inclusions.
     * @param {string} fullPath
     * @returns {boolean}
     */
    isGlobalScheduleInclusionDefined(fullPath) {
        const inclusions = this.getGlobalScheduleInclusions();

        fullPath = fullPath.toLowerCase();

        // Check if exact path is included
        if (inclusions[fullPath]) {
            return true;
        }

        const paths = this._getWildcardPaths(fullPath);
        // Check if any wildcard paths match
        return !!find(paths, path => inclusions[path]);
    }

    /**
     * Splits the provided path into matching wildcard paths
     * @example
     * // returns [/*, /shop/*, /shop/browse/*]
     * this._getWildcardPaths('/shop/browse')
     * @param {string} fullPath
     * @returns {Array<string>}
     */
    _getWildcardPaths(fullPath) {
        fullPath = fullPath.toLowerCase();

        const paths = [];

        forEach(fullPath.split('/'), (part, i) => {
            paths[i] = i === 0 ? '' : `${paths[i - 1]}/${part}`;
        });

        forEach(paths, (path, i) => {
            paths[i] = `${path}/*`;
        });

        return paths;
    }
}

module.exports = DynamicContentScheduleKeyService;



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/dynamic-content-schedule-key.service.js